/**
 * Configuration des navigations Layout par role.
 * Extrait de Layout.jsx pour respecter le plafond 200 lignes.
 *
 * Schema :
 *   buildNavItems({ effectiveRole, fieldMode, isAdmin, isCoordinator, isPartner })
 *   -> Array<{ path, label, Icon }>
 */

import {
  HomeIcon, TruckIcon, UsersIcon, ChartIcon, MessageIcon, MapIcon,
  SettingsIcon, CalendarIcon, ClockIcon, HelpIcon,
} from './icons.jsx';
import { BikeIcon } from './iconsExtra.jsx';

const BASE_NAV = Object.freeze([
  { path: '/', label: 'Accueil', Icon: HomeIcon },
  { path: '/plans', label: 'Tournées', Icon: TruckIcon },
  { path: '/clients', label: 'Clients', Icon: UsersIcon },
  { path: '/stats', label: 'Stats', Icon: ChartIcon },
  { path: '/chat', label: 'Chat', Icon: MessageIcon },
  { path: '/map', label: 'Carte', Icon: MapIcon },
  { path: '/appointments', label: 'RDV', Icon: CalendarIcon },
  { path: '/sms', label: 'SMS', Icon: MessageIcon },
  { path: '/scan-history', label: 'Scans', Icon: ClockIcon },
  { path: '/help', label: 'Aide', Icon: HelpIcon },
]);

const DRIVER_NAV = Object.freeze([
  { path: '/', label: 'Accueil', Icon: HomeIcon },
  { path: '/plans', label: 'Tournées', Icon: TruckIcon },
  { path: '/chat', label: 'Chat', Icon: MessageIcon },
  { path: '/map', label: 'Carte', Icon: MapIcon },
]);

// Partner nav (apporteur d'affaires read-only, ex: FEH).
const PARTNER_NAV = Object.freeze([
  { path: '/', label: 'Accueil', Icon: HomeIcon },
  { path: '/cee/dossiers', label: 'CEE', Icon: BikeIcon },
  { path: '/clients', label: 'Clients', Icon: UsersIcon },
  { path: '/map', label: 'Carte', Icon: MapIcon },
  { path: '/plans', label: 'Tournées', Icon: TruckIcon },
]);

const ADMIN_ITEMS = Object.freeze([
  { path: '/admin/users', label: 'Utilisateurs', Icon: UsersIcon },
  { path: '/admin/visibility', label: 'Visibilité', Icon: SettingsIcon },
]);

const CEE_ITEM = { path: '/cee/dossiers', label: 'CEE', Icon: BikeIcon };
const CEE_INBOX_ITEM = { path: '/cee/inbox', label: 'Inbox CEE', Icon: MessageIcon };
const CEE_PARAMS_ITEM = { path: '/cee/parametres', label: 'Parametres CEE', Icon: SettingsIcon };

/**
 * Calcule les nav items selon role + mode.
 * @param {{ fieldMode: boolean, effectiveRole?: string, isAdmin: boolean,
 *            isCoordinator: boolean, isPartner: boolean }} ctx
 * @returns {Array<{ path: string, label: string, Icon: any }>}
 */
export function buildNavItems(ctx) {
  if (ctx.fieldMode || ctx.effectiveRole === 'driver') return [...DRIVER_NAV];
  if (ctx.isPartner) return [...PARTNER_NAV];
  if (ctx.isAdmin) return [...BASE_NAV, CEE_ITEM, CEE_INBOX_ITEM, CEE_PARAMS_ITEM, ...ADMIN_ITEMS];
  if (ctx.isCoordinator) return [...BASE_NAV, CEE_ITEM, CEE_INBOX_ITEM];
  return [...BASE_NAV];
}

export { BASE_NAV, DRIVER_NAV, PARTNER_NAV, ADMIN_ITEMS, CEE_ITEM, CEE_INBOX_ITEM, CEE_PARAMS_ITEM };
